export default function LoaderEditMineralForm() {
  return (
    <div className="flex animate-pulse flex-col gap-4">
      <div className="flex flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_IMAGE"
        >
          صورة المعدن <span className="text-danger-600">*</span>
        </label>
        <div className="h-64 w-64 border-2 border-muted-500 bg-muted-100" />
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_TYPE"
        >
          نوع معدن <span className="text-danger-600">*</span>
        </label>

        <div className="h-11 w-full border-2 border-muted-500 bg-muted-100" />
      </div>
      <div className="flex gap-4">
        <div className="flex w-full flex-col gap-1">
          <label
            className="line-clamp-1 font-bold"
            htmlFor="ID_MINERAL_SYMBOL"
          >
            رمز معدن
          </label>
          <div className="h-11 w-full border-2 border-muted-500 bg-muted-100" />
        </div>
        <div className="flex w-full flex-col gap-1">
          <label
            className="font-bold"
            htmlFor="ID_MINERAL_NAME_AR"
          >
            اسم معدن بالعربية <span className="text-danger-600">*</span>
          </label>
          <div className="h-11 w-full border-2 border-muted-500 bg-muted-100" />
        </div>
        <div className="flex w-full flex-col gap-1">
          <label
            className="line-clamp-1 font-bold"
            htmlFor="ID_MINERAL_NAME_EN"
          >
            اسم معدن بالإنجليزية <span className="text-danger-600">*</span>
            <em className="font-normal text-accent-600">
              {' '}
              (المرجو عدم إدخال اسم المعدن بالعربية هنا)
            </em>
          </label>
          <div className="h-11 w-full border-2 border-muted-500 bg-muted-100" />
        </div>
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="line-clamp-1 font-bold"
          htmlFor="ID_MINERAL_STUDES_URL"
        >
          رابط الدراسات
        </label>
        <div className="h-11 w-full border-2 border-muted-500 bg-muted-100" />
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_DESCRIPTION_AR"
        >
          وصف المعدن بالعربية <span className="text-danger-600">*</span>
        </label>
        <div className="h-64 w-full border-2 border-muted-500 bg-muted-100" />
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_DESCRIPTION_EN"
        >
          وصف المعدن بالإنجليزية
        </label>
        <div className="h-64 w-full border-2 border-muted-500 bg-muted-100" />
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_HISTORY_AR"
        >
          تاريخ المعدن بالعربية <span className="text-danger-600">*</span>
        </label>
        <div className="h-64 w-full border-2 border-muted-500 bg-muted-100" />
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_HISTORY_EN"
        >
          تاريخ المعدن بالإنجليزية
        </label>
        <div className="h-64 w-full border-2 border-muted-500 bg-muted-100" />
      </div>
      <div className="flex flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_SOURCE_IMAGE"
        >
          صورة مصدر المعدن <span className="text-danger-600">*</span>
        </label>
        <div className="h-64 w-64 border-2 border-muted-500 bg-muted-100" />
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_SOURCE_AR"
        >
          مصدر المعدن بالعربية <span className="text-danger-600">*</span>
        </label>

        <div className="h-64 w-full border-2 border-muted-500 bg-muted-100" />
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_SOURCE_EN"
        >
          مصدر المعدن بالإنجليزية
        </label>
        <div className="h-64 w-full border-2 border-muted-500 bg-muted-100" />
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_COMPOUND_AR"
        >
          مركبات المعدن بالعربية
        </label>
        <div className="h-64 w-full border-2 border-muted-500 bg-muted-100" />
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="font-bold"
          htmlFor="ID_MINERAL_COMPOUND_EN"
        >
          مركبات المعدن بالإنجليزية
        </label>
        <div className="h-64 w-full border-2 border-muted-500 bg-muted-100" />
      </div>
    </div>
  )
}
